  <div class="tabs-gallery">
    <tabs :options="{ useUrlFragment: false }">
        <tab :name="$t('Image Gallery')">
            <appImageEditorLocalImages />
        </tab>
        <tab :name="$t('Upload your own')">
            <appImageEditorUploadedImages/>
        </tab>       
    </tabs>
</div>